// extracted by mini-css-extract-plugin
export default {"mn-alert":"index_mn-alert__NsQRe"};